import "./GlContribution.scss";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined';
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { IoClose, IoDocumentTextSharp } from "react-icons/io5";
import { MdClose, MdEmail, MdOutlineNumbers, MdPhone } from "react-icons/md";
import { IoMdApps } from "react-icons/io";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GridLoader, ScaleLoader } from "react-spinners";
import { sanitizeText } from "../../../utils/genericFunctions.js";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { TbGenderEpicene } from "react-icons/tb";
import { PiGenderMaleBold, PiGenderFemaleBold } from "react-icons/pi";
import Contributions from "../../../components/contributions/Contributions.jsx";
import { useTranslation } from "react-i18next";

const GlContribution = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const location = useLocation();
  const parts = location.pathname.split("/");
  const [entityId, setEntityId] = useState(parts[parts.length - 1]);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [additionalActionsMenu, setAdditionalActionsMenu] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const [currentAction, setCurrentAction] = useState("");
  const [entityFilesData, setEntityFilesData] = useState([]);
  const [entityTraceData, setEntityTraceData] = useState([]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [entityData, setEntityData] = useState({});
  const [reportGroupArray, setReportKeysArray] = useState(["contribution"]);

  const goBack = () => {
    navigate(-1);
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "underReview") {

      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const fetchEntity = async (id) => {
    try {
      const res = await newRequest.get(`/allEntity/findById/${id}`);
      setEntityData(res.data);
      await fetchEntityFiles(entityId);
      await fetchEntityTrace(res.data.ent_code);
    } catch (err) {
      console.log(err);
    }
  };


  const fetchEntityFiles = async (entity_docid) => {
    try {
      const res = await newRequest.post(
        "/files/findEntityFiles",
        {
          fl_org_code: currentUser.usr_org_code,
          entity_docid: entity_docid,
        }
      );

      setEntityFilesData(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  const fetchEntityTrace = async (entity_code) => {
    try {
      const res = await newRequest.post(
        "/trace/findEnt",
        {
          trc_ent_code: entity_code,
        }
      );
      setEntityTraceData(res.data);
    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    fetchEntity(entityId);
  }, [entityData?.ent_code]);

  return (
    <motion.div
      className="gl-contribution"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="gl-contribution-main-wrapper">
          <div className="center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <div className="navbar-left">
                  <h1 className="main-title">{entityData?.ent_name}</h1>
                </div>
                <div className="navbar-right">
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="none"
                    endIcon={<IoDocumentTextSharp />}
                    onClick={() => setReportsDialogOpen(true)}>
                    {t('reports')}
                  </CustomLoadingButton>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="right"
                    endIcon={<MdClose />}
                    onClick={goBack}>
                    {t('close')}
                  </CustomLoadingButton>
                </div>
              </div>
              {/* CONTRIBUTIONS */}
              <Contributions entCode={entityData?.ent_code} />
              {/* ATTACHMENTS */}
              <ExpandableComponent
                title={t('attachments').toUpperCase()}
                subtitle={
                  <span className="sub-title">{entityFilesData.length === 1 ? `1 ${t('attachment').toUpperCase()}` : `${entityFilesData.length} ${t('attachments').toUpperCase()}`} </span>
                }
                bgColor="#fff"
                defaultExpanded={true}
              >
                <motion.div
                  className="attachments"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 1 } }}
                  exit={{ opacity: 0, transition: { duration: 1 } }}>
                  {/* <FileUploadComponent documentNo={entCode} documentId={entityId} documentType="entity" fetchDocumentAttachments={() => fetchEntityFiles(entityId)} uploadFolder="entity" /> */}
                  <AllFiles filesList={entityFilesData} />
                </motion.div>
              </ExpandableComponent>
            </div>
          </div>
          <div className="right-wrapper">
            <h1 className={`status ${entityData?.ent_status}`}>{`${t('status').toUpperCase()} ${entityData?.ent_status}`}</h1>
            <div className="logo">
              {entityData?.ent_photo_url ?
                <img src={entityData?.ent_photo_url} alt="" className="logo" /> : <BrokenImageOutlinedIcon style={{ height: "120px", width: "120px" }} />}
            </div>
            <div className="right-content">
              <hr className="separator-h" />
              <h1 className="main-title">{entityData?.ent_name}</h1>
              <hr className="separator-h" />
              <span className="email-phone-details">
                <MdOutlineNumbers className="icon" /> <h1 className="sub-title">{entityData?.ent_code}</h1>
              </span>
              <span className="email-phone-details">
                <MdEmail className="icon" /> <h1 className="sub-title">{entityData?.ent_email || "Unspecified"}</h1>
              </span>
              <span className="email-phone-details">
                <MdPhone className="icon" /> <h1 className="sub-title">{entityData?.ent_phone_no || "Unspecified"}</h1>
              </span>
              <span className="email-phone-details">
                <IoMdApps className="icon" /> <h1 className="sub-title">{entityData?.aent_name_xx || ""}</h1>
              </span>
              {!["Male", "Female"].includes(entityData?.ent_gender) && <span className="email-phone-details"><TbGenderEpicene className="icon" /> {entityData?.ent_gender}</span>}
              {["Male"].includes(entityData?.ent_gender) && <span className="email-phone-details"><PiGenderMaleBold className="icon" /> {entityData?.ent_gender}</span>}
              {["Female"].includes(entityData?.ent_gender) && <span className="email-phone-details"><PiGenderFemaleBold className="icon" /> {entityData?.ent_gender}</span>}
            </div>
          </div>
        </div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: sanitizeText(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>

      {/* <NotifyDialog
        open={isNotifyDialogOpen}
        title={notifyDialogTitle}
        text={notifyDialogText}
        onClose={() => setIsNotifyDialogOpen(false)}
      /> */}

      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )
      }
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: entityData?.ent_code,
                  docType: "Contribution",
                  docId: entityData?._id,
                  entity_name: entityData?.ent_name,
                  entity_email: entityData?.ent_email,
                  entity_phone_no: entityData?.ent_phone_no,
                  entity_code: entityData?.ent_code,
                  entity_tax_pin: entityData?.ent_tax_no,
                }} />
            </div>
          </div>
        </motion.div>
      )}

    </motion.div>
  );
};



export default GlContribution;
